import React from "react";
import "./SealRegistrationStepIndicator.scss";

const STEPS = ["Register", "Payment", "Confirmation"];

interface SealRegistrationStepIndicatorProps {
  currentStep: 1 | 2 | 3;
}

export const SealRegistrationStepIndicator: React.FC<
  SealRegistrationStepIndicatorProps
> = ({ currentStep }) => (
  <div className="seal-step-indicator">
    {STEPS.map((label, index) => {
      const stepNumber = index + 1;
      const isActive = stepNumber <= currentStep;
      return (
        <div key={label} className="seal-step-indicator-item">
          <div
            className={`seal-step-indicator-circle ${
              isActive ? "seal-step-indicator-circle--active" : ""
            }`}
          >
            {stepNumber}
          </div>
          <div
            className={`seal-step-indicator-label ${
              isActive ? "seal-step-indicator-label--active" : ""
            }`}
          >
            {label}
          </div>
          {index < STEPS.length - 1 && (
            <div className="seal-step-indicator-line" />
          )}
        </div>
      );
    })}
  </div>
);
